<template>
  <div class="content">
    <h1>Main panel</h1>
    <p>Select something from sidebar</p>
    <div class="d-flex">
      <InfoCard
        v-for="(statistic, index) in statistics"
        :key="index"
        :icon="statistic.icon"
        :title="statistic.display_name"
        :value="statistic.value"
      />
    </div>
    <title-card title="Statistics" class="mt-2">
      <div class="d-flex ma-5 ga-10">
        <div class="d-flex flex-column ga-2 align-center w-50">
          <div class="d-flex w-100 justify-space-between">
          <v-autocomplete
              v-model="specialityIds"
              :items="specialities"
              label="Specialities"
              :item-title="(item) => `${item?.name}`"
              item-value="id"
              color="primary"
              multiple
              prepend-icon="mdi-account-hard-hat-outline"
              class="w-100"
              chips
              closable-chips
          >
          </v-autocomplete>
          <v-checkbox
              v-model="checkboxValue"
              @click="selectAll"
          ></v-checkbox>
          </div>
          <v-date-input
              v-model="dates"
              label="Select range"
              multiple="range"
              class="w-100"
              color="primary"
          ></v-date-input>
        </div>
        <div class="w-50">
          <v-data-table
              :headers="[{title:'Speciality', key: 'id', value: item => `${specialities.find(speciality => speciality.id == item.id).name}`}, {title:'Count', key: 'value'}]"
              :items="specialitiesCounts"
              hide-default-footer
              class="w-100"
              items-per-page="-1"
              density="compact"
          ></v-data-table>
        </div>
      </div>
      <v-btn @click="fetchSpecialities" class="w-auto ma-3">Search</v-btn>
    </title-card>
  </div>
</template>

<script>
import config from "@/helpers/api";
import InfoCard from "@/Admin/components/InfoCard.vue";
import TitleCard from "@/Admin/components/TitleCard.vue";
export default {
  name: "MainView",
  watch: {
    specialityIds(newValue) {
      this.checkboxValue = newValue.length === this.specialities.length
    }
  },
  methods: {
    fetchSpecialities() {
      fetch(`${config.baseURL}/statistics/filtered`, {
        method: "POST",
        headers: config.headers,
        body: JSON.stringify({
          dates: [this.dates[0], this.dates[this.dates.length - 1]],
          speciality_ids: this.specialityIds,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          this.specialitiesCounts = Object.entries(response)
              .map(entry => {
                return {'id': entry[0], 'value': entry[1]};
              });
        });
    },
    selectAll() {
      if (!this.checkboxValue) {
        this.specialityIds = [...this.specialities.map(item => item.id)];
      } else {
        this.specialityIds = []
      }
    }
  },
  components: {TitleCard, InfoCard },
  data() {
    return {
      statistics: [],
      dates: [],
      specialityIds: [],
      specialities: [],
      specialitiesCounts: [],
      checkboxValue: false,
    };
  },
  mounted() {
    fetch(`${config.baseURL}/statistics`, {
      method: "GET",
      headers: config.headers,
      body: JSON.stringify(this.form),
    })
      .then((response) => response.json())
      .then((response) => {
        this.statistics = response;
      });

    fetch(`${config.baseURL}/specialities`, {
      method: "GET",
      headers: config.headers,
    })
        .then((response) => response.json())
        .then((response) => {
          this.specialities = response.data;
        });
    },
};
</script>

<style scoped>
.content {
  width: 100%;
}

.info-card-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.info-container {
  margin: 20px 0;
}
</style>
